import React, { useContext, useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';
import { Contract, providers } from 'ethers';
import { createEthereumProvider } from '../ethereum';
import config from '../config';
import { IContract } from '../types';

export interface IContractContext {
  provider: providers.JsonRpcProvider;
  tokenContract: IContract;
}

const ContractContext = React.createContext<Maybe<IContractContext>>(null);
const defaultProvider = createEthereumProvider((window as any).ethereum || config.providerUrl);

export const ContractProvider = ({ children = null as any }) => {
  const { library } = useWeb3React();
  const [provider, setProvider] = useState(defaultProvider);
  const [tokenContract, setTokenContract] = useState(
    new Contract(config.tokenAddress, config.tokenAbi, defaultProvider)
  );

  useEffect(() => {
    const nextProvider = createEthereumProvider(library?.provider || config.providerUrl);
    setProvider(nextProvider);
    setTokenContract(new Contract(config.tokenAddress, config.tokenAbi, nextProvider));
  }, [library]);

  return (
    <ContractContext.Provider
      value={{
        provider,
        tokenContract: { contract: tokenContract, address: config.tokenAddress },
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};

export const useContracts = () => {
  const context = useContext(ContractContext);
  if (!context) {
    throw new Error('Component rendered outside the provider tree');
  }
  return context;
};
